// For now, this is just going to be a const. In the future
// we could make it a function that takes in a esport slug
// or if we decide to store the value in the BE, we can remove
// this completely.
export const restrictedEsportLabel = 'Youth Program'
